/*eslint eqeqeq: "off"*/
import * as React from 'react';
import './Tabel.css';

interface IFilterParam {
    sortItem: string[];
    sortCol: 'default' | 'alfabet';
    sortUp: boolean;
}

interface IFilterItem {
    desc: string;
    filterList: Map<string, string>;
    typeFilter: string;
    sortFilter: IFilterParam;
    width?: number;
}

export interface IFilterItems {
    [string: string]: IFilterItem;
}

interface IProps {
    startFilterName?: string;
    startFilterVal?: string;
    filterItems: IFilterItems;
    reports: any[];
    colList: string[];
    selectFindItem: Function;
    OnClikcFilter: Function;
    SelectedItem?: Function;
    selectedOne?: boolean;
    IDCol?: string;
    minWindth: number;
    initialcheckItem?: string;
}

export interface IState {
    idReport: string;
    countCheck: number;
    checkItem: string[];
    openWindowDelete: boolean;
    openWinFilter: string;
    PositionFilter: { X: number; Y: number };
}

class Tabel extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            idReport: '',
            countCheck: 0,
            checkItem: props.initialcheckItem ? [props.initialcheckItem] : [],
            openWindowDelete: false,
            openWinFilter: '',
            PositionFilter: { X: 0, Y: 0 }
        };
    }

    componentWillReceiveProps(nextProps: IProps) {
        if (nextProps.initialcheckItem !== this.props.initialcheckItem && nextProps.initialcheckItem != undefined) {
            this.setState({
                checkItem: [nextProps.initialcheckItem]
            });
        }
    }

    private checkingItem(id: string, index: number) {
        console.log(id);
        let ItemTemp = this.props.reports[index];
        let ColId = ItemTemp.id;
        if (this.props.IDCol != undefined) {
            ColId = ItemTemp[this.props.IDCol];
        }
        if (ColId === id) {
            let checkItemTemp: string[] = this.state.checkItem;
            let countCheckTemp: number = this.state.countCheck;
            if (checkItemTemp.indexOf(id) == -1) {
                if (this.props.selectedOne != undefined && this.props.selectedOne) {
                    countCheckTemp = 1;
                    checkItemTemp = [id];
                } else {
                    checkItemTemp.push(id);
                    countCheckTemp = countCheckTemp + 1;
                }
            } else {
                if (this.props.selectedOne != undefined && this.props.selectedOne) {
                    countCheckTemp = 0;
                    checkItemTemp = [];
                } else {
                    let indexItem = checkItemTemp.indexOf(id);
                    checkItemTemp.splice(indexItem, 1);
                    countCheckTemp = countCheckTemp - 1;
                }
            }
            this.setState({ countCheck: countCheckTemp, checkItem: checkItemTemp });
            if (this.props.SelectedItem != undefined) {
                this.props.SelectedItem(checkItemTemp, index, countCheckTemp);
            }
        }
    }

    private OnClickFilter(key: string, PositionX: number, PositionY: number) {
        let NewOpenWinFilter = '';
        if (this.state.openWinFilter != key) NewOpenWinFilter = key;
        this.setState({ openWinFilter: NewOpenWinFilter, PositionFilter: { X: PositionX, Y: PositionY } });
    }

    private convertStrOnType(nameCol: string, value: string) {
        if (this.props.filterItems[nameCol]?.typeFilter === 'Date') {
            //let dateFormat = require("dateformat");
            //let formatDate = "yyyy-mm-dd' 'HH:MM:ss";
            //return dateFormat(value, formatDate);
            return new Date(value).toLocaleString();
        } else {
            return value;
        }
    }

    render() {
        if (this.props.colList.length === 0) {
            return null;
        }

        let thead = [];
        /*
        let theadNoVisiabl = []
        let countTHead = 0;
        let lengthTHead = Object.keys(this.props.filterItems).length;
        */
        let WidthCol: number[] = [];
        let CountWidthCol: number = 0;
        let SumWidthCol: number = 48;
        for (let index = 0; index < this.props.colList.length; index++) {
            let key = this.props.colList[index];
            let TempItem: IFilterItem = this.props.filterItems[key];
            if (TempItem != null) {
                if (Object.hasOwn(TempItem, 'width')) {
                    if (TempItem.width != undefined) {
                        WidthCol.push(TempItem.width);
                        SumWidthCol += TempItem.width;
                    } else {
                        WidthCol.push(NaN);
                        CountWidthCol++;
                    }
                } else {
                    WidthCol.push(NaN);
                    CountWidthCol++;
                }
            }
        }
        let ItemWidthCol: number = 0;
        if (CountWidthCol > 0 && SumWidthCol < this.props.minWindth) {
            ItemWidthCol = (this.props.minWindth - SumWidthCol) / CountWidthCol;
        }
        for (let index = 0; index < WidthCol.length; index++) {
            if (isNaN(WidthCol[index])) {
                WidthCol[index] = ItemWidthCol;
            }
        }

        for (let count = 0; count < this.props.colList.length; count++) {
            let key = this.props.colList[count];
            if (this.props.filterItems[key]) {
                let ColorSVG = this.state.openWinFilter == key ? '#66C3D0' : '#6C6B6B';
                if (this.props.filterItems[key]?.sortFilter.sortItem.length > 0) ColorSVG = '#66C3D0';
                thead.push(
                    <th
                        key={count + 1}
                        style={{ width: WidthCol[count] + 'px', minWidth: '7em' }}
                        className={'Alarms__table_th Alarms__table_colum' + (count + 1)}>
                        <div style={{ display: 'flex' }}>
                            <div
                                style={{
                                    //transform: this.state.openWinFilter == key ? 'rotate(-90deg)' : 'rotate(90deg)',fill="#AEAEAE"
                                    fontWeight: 300,
                                    fontSize: '1em',
                                    color: this.state.openWinFilter == key ? '#66C3D0' : '#6C6B6B',
                                    height: '1em',
                                    width: '1em',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    paddingRight: '5px',
                                    marginLeft: '-5px'
                                }}
                                onClick={(evn: React.MouseEvent) => {
                                    let delta = 0;
                                    let sumX = evn.movementX;
                                    let sumY = evn.movementY + 25;
                                    if (evn.currentTarget.parentElement?.offsetLeft != undefined) {
                                        sumX += evn.currentTarget.parentElement?.offsetLeft;
                                    }
                                    if (evn.currentTarget.parentElement?.parentElement?.offsetLeft != undefined) {
                                        sumX += evn.currentTarget.parentElement?.parentElement?.offsetLeft;
                                    }
                                    if (
                                        evn.currentTarget.parentElement?.parentElement?.parentElement?.clientWidth !=
                                        undefined
                                    ) {
                                        delta =
                                            evn.currentTarget.parentElement?.parentElement?.parentElement?.clientWidth -
                                            sumX;
                                    }
                                    if (delta < 275) sumX = sumX + delta - 235;
                                    this.OnClickFilter(key, sumY, sumX);
                                }}>
                                <svg
                                    style={{ cursor: 'pointer' }}
                                    width="15"
                                    height="12"
                                    viewBox="0 0 15 12"
                                    fill={ColorSVG}
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.1464 12C6.0875 12 6.02928 11.9864 5.97647 11.9574C5.87221 11.8993 5.80789 11.7921 5.80789 11.6771V5.92381L0.100001 0.552088C0.00251102 0.461042 -0.0266006 0.322858 0.0255294 0.200818C0.0776594 0.0794232 0.201553 0 0.338309 0H14.6619C14.7993 0 14.9232 0.0787775 14.9746 0.200818C15.0268 0.322213 14.997 0.461042 14.8995 0.552734L9.19296 5.92381V10.2049C9.19296 10.3218 9.12728 10.429 9.02235 10.4858L6.3143 11.958C6.26217 11.9864 6.20395 12 6.1464 12ZM1.16359 0.645717L6.38403 5.55898C6.44835 5.61967 6.48491 5.70232 6.48491 5.78756V11.1205L8.51594 10.0164V5.78756C8.51594 5.70103 8.5525 5.61709 8.61614 5.55898L13.8359 0.645717H1.16359Z" />
                                </svg>
                            </div>
                            <div
                                style={{ color: this.state.openWinFilter == key ? '#66C3D0' : '#6C6B6B' }}
                                title={this.props.filterItems[key].desc}>
                                {this.props.filterItems[key].desc}
                            </div>
                        </div>
                    </th>
                );
            }
            /*
            countTHead++;
            thead.push(<th style={{ width: WidthCol[count] + '%', minWidth: '7em' }} className={'Alarms__table_th Alarms__table_colum' + countTHead}><FilterReport
                lastElem={countTHead === lengthTHead ? true : false}
                statusFilterSelect={this.props.filterItems[key].statusFilterSelect}
                changeStatusSelect={(nameItem: string) => { this.props.changeStatusFilterSelect(nameItem) }}
                OnClikcFilter={(nameButton: string) => this.props.OnClikcFilter(nameButton)}
                filterName={key}
                filterDesc={this.props.filterItems[key].desc}
                filterItem={this.props.filterItems[key]}
                selectedValue={this.props.filterItems[key].sortFilter}
                selectCallBack={(item: string, value: string, key: string) => { this.props.selectFindItem(item, value, key) }}
            /></th>)
            theadNoVisiabl.push(<th style={{ width: WidthCol[count] + '%', minWidth: '7em' }} className={'Alarms__table_th Alarms__table_colum' + countTHead}>
                <div>
                    <div style={{ display: 'flex' }}>
                        <div>{key}</div>
                        <div style={{
                            fontWeight: 300,
                            fontSize: '1em',
                            height: '1em',
                            width: '1em',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }} >{">"}</div>
                    </div>
                    <div style={{
                        position: 'fixed',
                        background: '#fff',
                        width: '19.5em',
                        marginTop: '1em',
                        overflow: 'hidden',
                        opacity: 0,
                        maxHeight: 0
                    }}></div>
                </div>
            </th>)*/
        }

        let WindowsFilter = () => {
            let key = this.state.openWinFilter;
            return this.state.openWinFilter == '' ? (
                <React.Fragment></React.Fragment>
            ) : (
                <div style={{ display: 'contents' }} className={'Alarms__table Alarms__table_tr Alarms__table_th'}>
                    <FilterReport
                        Position={this.state.PositionFilter}
                        OnClikcFilter={(nameButton: string) => {
                            this.props.OnClikcFilter(nameButton);
                            this.setState({ openWinFilter: '' });
                        }}
                        filterName={key}
                        filterItem={this.props.filterItems[key]}
                        selectedValue={this.props.filterItems[key].sortFilter}
                        selectCallBack={(item: string, value: string, key: string) => {
                            this.props.selectFindItem(item, value, key);
                        }}
                    />
                </div>
            );
        };

        return (
            <React.Fragment key="keyEdit">
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                        minWidth: this.props.minWindth + 'px'
                    }}>
                    <div
                        style={{
                            width: '100%',
                            height: '100%'
                        }}>
                        <div
                            style={{
                                overflow: 'hidden',
                                height: '5em',
                                zIndex: 2
                                /*position:'absolute'*/
                            }}>
                            <table className={'Alarms__table'}>
                                <thead>
                                    <tr className={'Alarms__table_tr'}>
                                        <th
                                            key={0}
                                            style={{ width: '48px' }}
                                            className={'Alarms__table_th Alarms__table_colum0'}></th>
                                        {thead}
                                    </tr>
                                </thead>

                                {/*this.props.reports.map((rep, index) => {

                                    let arrTD = [];
                                    for (let count = 0; count < this.props.colList.length; count++) {
                                        arrTD.push(<td style={{}} className={'Alarms__table_td'}>{rep[this.props.colList[count]]}</td>)
                                    }

                                    return (<tr className={'Alarms__table_tr'} key={index} style={{ background: index % 2 == 1 ?'#e0e4eb':'#fff'}} >
                                        <td className={'Alarms__table_td'}><div style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            width: '100%'
                                        }}><input type='checkbox' checked={this.state.checkItem.indexOf(rep.id) != -1}
                                                onChange={() => { this.checkingItem(rep.id, index) }} /></div>
                                        </td>
                                        {arrTD}
                                    </tr>)
                                })*/}
                            </table>
                        </div>

                        <div
                            style={{
                                overflowX: 'hidden',
                                overflowY: 'auto',
                                height: 'calc(100% - 5em)'
                            }}>
                            <table className={'Alarms__table'}>
                                <thead></thead>
                                <tbody>
                                    {this.props.reports.map((rep, index) => {
                                        let checkedItem = false;
                                        if (this.props.IDCol != undefined)
                                            checkedItem = this.state.checkItem.indexOf(rep[this.props.IDCol]) != -1;
                                        else checkedItem = this.state.checkItem.indexOf(rep.id) != -1;
                                        let arrTD = [];
                                        for (let count = 0; count < this.props.colList.length; count++) {
                                            let text = this.convertStrOnType(
                                                this.props.colList[count],
                                                rep[this.props.colList[count]]
                                            );
                                            arrTD.push(
                                                <td
                                                    key={index * this.props.colList.length + count}
                                                    style={{
                                                        width: WidthCol[count] + 'px',
                                                        minWidth: '7em',
                                                        textOverflow: 'ellipsis',
                                                        overflow: 'hidden',
                                                        whiteSpace: 'nowrap'
                                                    }}
                                                    className={'Alarms__table_td'}
                                                    title={text}>
                                                    {text}
                                                </td>
                                            );
                                        }

                                        return (
                                            <tr
                                                className={'Alarms__table_tr'}
                                                key={index}
                                                style={{ background: index % 2 == 1 ? '#e0e4eb' : '#fff' }}>
                                                <td style={{ width: '48px' }} className={'Alarms__table_td'}>
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            width: '100%'
                                                        }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={checkedItem}
                                                            onChange={() => {
                                                                if (this.props.IDCol != undefined)
                                                                    this.checkingItem(rep[this.props.IDCol], index);
                                                                else this.checkingItem(rep.id, index);
                                                            }}
                                                        />
                                                    </div>
                                                </td>
                                                {arrTD}
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                        {WindowsFilter()}
                    </div>
                </div>
                {this.state.openWindowDelete && (
                    <div
                        style={{
                            position: 'absolute',
                            height: '100%',
                            width: '100%',
                            top: 0,
                            left: 0,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                        <div
                            style={{
                                maxHeight: '18.1em',
                                height: '100%',
                                maxWidth: '36.6em',
                                width: '100%',
                                background: '#fff',
                                boxShadow: '0px 17px 14px rgba(0, 0, 0, 0.08)',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center'
                            }}>
                            <div
                                style={{
                                    height: '3em',
                                    width: '100%',
                                    background: '#E8F3F5',
                                    boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.1)'
                                }}></div>
                            <div
                                style={{
                                    height: '4.4em',
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}>
                                <img src={'images/trashCan.svg'} />
                            </div>
                            <div
                                style={{
                                    height: '5.5em',
                                    width: '90%',
                                    textAlign: 'center'
                                }}>
                                <span
                                    style={{
                                        fontSize: '1em',
                                        fontWeight: 300,
                                        color: '#626161'
                                    }}>{`Вы действительно хотите удалить ${this.state.countCheck} протокол(а) обучения?`}</span>
                            </div>
                            <div
                                style={{
                                    height: '4.4em',
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'space-evenly',
                                    alignItems: 'center'
                                }}>
                                <span
                                    onClick={() => {
                                        this.setState({ openWindowDelete: false });
                                    }}>
                                    Cancel
                                </span>
                                {/*<span onClick={() => { this.deleteItem() }}>Delete</span>*/}
                            </div>
                        </div>
                    </div>
                )}
            </React.Fragment>
        );
    }
}

export default Tabel;

interface IFilterReportProps {
    filterName: string;
    filterItem: IFilterItem;
    selectedValue: IFilterParam;
    selectCallBack: Function;
    OnClikcFilter: Function;
    Position: { X: number; Y: number };
}
interface IFilterReportState {
    stateOpen: boolean;
    otherStateOpen: boolean;
}

class FilterReport extends React.Component<IFilterReportProps, IFilterReportState> {
    constructor(props: IFilterReportProps) {
        super(props);
        this.state = {
            stateOpen: false,
            otherStateOpen: false
        };
    }

    private clickAlfaDef(name: string, type: string) {
        this.props.selectCallBack(name, type, type);
        this.props.OnClikcFilter(name);
    }

    render() {
        let forList: any = [];

        let filterDefault = false;
        let filterFromList = false;
        let filterAlfabet = false;
        if (this.props.filterItem.typeFilter == 'Date' || this.props.filterItem.typeFilter == 'DateNotA') {
            filterAlfabet = true;

            let dateFormat = require('dateformat');
            let formatDate = "yyyy-mm-dd'T'HH:MM:ss";

            let FirstDate: string | undefined =
                this.props.selectedValue.sortItem.length > 0
                    ? dateFormat(this.props.selectedValue.sortItem[0], formatDate)
                    : undefined;
            let LastDate: string | undefined =
                this.props.selectedValue.sortItem.length > 1
                    ? dateFormat(this.props.selectedValue.sortItem[1], formatDate)
                    : undefined;
            forList.push(
                <div
                    key="Date1"
                    style={{
                        height: '2.4em',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '0 0 0 2.4em',
                        overflow: 'hidden',
                        cursor: 'pointer',
                        background: '#fff'
                    }}>
                    <input
                        id="First"
                        style={{}}
                        type="datetime-local"
                        step="1"
                        placeholder="С какой даты"
                        defaultValue={FirstDate != undefined ? FirstDate : '1970-01-01T00:00:01'}
                        onBlur={(event: React.ChangeEvent<HTMLInputElement>) =>
                            this.props.selectCallBack(this.props.filterName, event.target.value, 'First')
                        }
                        //onChange={(event: React.ChangeEvent) => this.props.selectCallBack(this.props.filterName, event.target.value, "First")}
                    />
                </div>
            );
            forList.push(
                <div
                    key="Date2"
                    style={{
                        height: '2.4em',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '0 0 0 2.4em',
                        overflow: 'hidden',
                        cursor: 'pointer',
                        background: '#fff'
                    }}>
                    <input
                        id="Last"
                        style={{}}
                        type="datetime-local"
                        step="1"
                        placeholder="По какой дату"
                        defaultValue={LastDate != undefined ? LastDate : '1970-01-01T01:01:01'}
                        onBlur={(event: React.ChangeEvent<HTMLInputElement>) =>
                            this.props.selectCallBack(this.props.filterName, event.target.value, 'Last')
                        }
                        //onChange={(event: React.ChangeEvent) => this.props.selectCallBack(this.props.filterName, event.target.value, "Last")}
                    />
                </div>
            );
            forList.push(
                <div
                    key="Date3"
                    style={{
                        height: '2.4em',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '0 0 0 2.4em',
                        overflow: 'hidden',
                        cursor: 'pointer',
                        background: '#fff'
                    }}>
                    <input
                        id="apply"
                        style={{}}
                        type="button"
                        value="Применить"
                        onClick={() => this.props.OnClikcFilter(this.props.filterName)}
                        //onChange={(event: React.ChangeEvent) => this.props.selectCallBack(this.props.filterName, event.target.value, "Last")}
                    />
                </div>
            );
        } else if (this.props.filterItem.typeFilter == 'List' || this.props.filterItem.typeFilter == 'ListNotA') {
            filterDefault = true;
            filterFromList = true;
            filterAlfabet = true;
            this.props.filterItem.filterList.forEach((value: string, key: any, arr: any) => {
                //console.debug(arr);
                let selected = false;
                if (this.props.selectedValue !== undefined && this.props.selectedValue.sortItem.length > 0) {
                    if (
                        this.props.selectedValue.sortItem.findIndex((item: string, index: number) => {
                            return item === value ? true : false;
                        }) > -1
                    ) {
                        selected = true;
                    }
                }
                forList.push(
                    <div
                        style={{
                            height: '2.4em',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: '0 0 0 2.4em',
                            overflow: 'hidden',
                            cursor: 'pointer',
                            background: selected ? 'rgba(202, 234, 240, 0.5)' : '#fff'
                        }}
                        key={key}
                        onClick={() => {
                            this.props.selectCallBack(this.props.filterName, key, key);
                        }}>
                        <span>{value}</span>
                        {selected && (
                            <div style={{ margin: '0.5em 1em' }}>
                                <svg
                                    width="10"
                                    height="10"
                                    viewBox="0 0 10 10"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M8.39959 0.429971C6.89263 2.89964 5.31526 5.32212 3.68155 7.69741C2.9492 6.98954 2.20276 6.28168 1.47041 5.57381C0.653553 4.78729 -0.543561 6.10864 0.273293 6.91089C1.24507 7.85471 2.21684 8.78281 3.2027 9.72663C3.51254 10.0255 4.10406 10.1514 4.39982 9.72663C6.30112 7.021 8.132 4.23672 9.85021 1.38952C10.4699 0.36705 9.00519 -0.576773 8.39959 0.429971Z"
                                        fill="#66C3D0"
                                    />
                                </svg>
                            </div>
                        )}
                    </div>
                );
            });
        } else if (this.props.filterItem.typeFilter == 'Input' || this.props.filterItem.typeFilter == 'InputNotA') {
            filterDefault = true;
            filterAlfabet = true;
            let value: string =
                this.props.selectedValue.sortItem.length > 0 ? this.props.selectedValue.sortItem[0] : '';
            forList.push(
                <div
                    key="Input1"
                    style={{
                        height: '2.4em',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '0 0 0 2.4em',
                        overflow: 'hidden',
                        cursor: 'pointer',
                        background: '#fff'
                    }}>
                    <input
                        id="Last"
                        style={{}}
                        type="text"
                        defaultValue={value}
                        onBlur={(event: React.ChangeEvent<HTMLInputElement>) =>
                            this.props.selectCallBack(this.props.filterName, event.target.value, 'Input')
                        }
                        //onChange={(event: React.ChangeEvent) => this.props.selectCallBack(this.props.filterName, event.target.value, "Last")}
                    />
                </div>
            );
            forList.push(
                <div
                    key="Input2"
                    style={{
                        height: '2.4em',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '0 0 0 2.4em',
                        overflow: 'hidden',
                        cursor: 'pointer',
                        background: '#fff'
                    }}>
                    <input
                        id="apply"
                        style={{}}
                        type="button"
                        value="Применить"
                        onClick={() => this.props.OnClikcFilter(this.props.filterName)}
                    />
                </div>
            );
        }

        if (
            this.props.filterItem.typeFilter == 'DateNotA' ||
            this.props.filterItem.typeFilter == 'ListNotA' ||
            this.props.filterItem.typeFilter == 'InputNotA'
        )
            filterAlfabet = false;

        return (
            <div>
                <div
                    style={{
                        position: 'absolute',
                        background: '#fff',
                        boxShadow: '0px 0px 4px 4px rgba(0, 0, 0, 0.1)',
                        width: '19.5em',
                        marginTop: '1em',
                        overflow: 'hidden',
                        opacity: 1,
                        transition: 'opacity .3s, max-height .2s',
                        //maxHeight: '30.8em',
                        top: this.props.Position.X + 5,
                        left: this.props.Position.Y - 50
                    }}>
                    {filterDefault ? (
                        <div
                            style={{
                                height: '2.4em',
                                display: 'flex',
                                alignItems: 'center',
                                padding: '0 0 0 1.2em',
                                cursor: 'pointer',
                                color: this.props.selectedValue.sortCol === 'default' ? '#66C3D0' : '#727272'
                            }}
                            onClick={() => {
                                this.clickAlfaDef(this.props.filterName, 'default');
                            }}>
                            По умолчанию
                        </div>
                    ) : (
                        <React.Fragment />
                    )}

                    {filterAlfabet ? (
                        <div
                            style={{
                                height: '2.4em',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '0 0 0 1.2em',
                                cursor: 'pointer',
                                color: this.props.selectedValue.sortCol === 'alfabet' ? '#66C3D0' : '#727272'
                            }}
                            onClick={() => {
                                this.clickAlfaDef(this.props.filterName, 'alfabet');
                            }}>
                            <span>По алфавиту</span>
                            <span style={{ margin: '0 1em' }}>{this.props.selectedValue.sortUp ? '↑' : '↓'}</span>
                        </div>
                    ) : (
                        <React.Fragment />
                    )}

                    {filterFromList ? (
                        <React.Fragment>
                            <div
                                style={{
                                    height: '2.4em',
                                    display: 'flex',
                                    alignItems: 'center',
                                    padding: '0 0 0 1.2em',
                                    cursor: 'pointer',
                                    color: this.props.selectedValue.sortItem.length > 0 ? '#66C3D0' : '#727272'
                                }}
                                onClick={() => {
                                    this.setState({ otherStateOpen: !this.state.otherStateOpen });
                                }}>
                                Из списка
                            </div>

                            <div
                                style={{
                                    overflow: 'hidden',
                                    opacity: this.state.otherStateOpen ? 1 : 0,
                                    transition: 'opacity .3s, max-height .2s',
                                    maxHeight: this.state.otherStateOpen ? '25em' : '0',
                                    overflowY: 'auto'
                                }}>
                                {forList}
                            </div>

                            <div
                                style={{
                                    height: '2.4em',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    padding: '0 0 0 2.4em',
                                    overflow: 'hidden',
                                    cursor: 'pointer',
                                    background: '#fff'
                                }}>
                                <input
                                    id="apply"
                                    style={{}}
                                    type="button"
                                    value="Применить"
                                    onClick={() => this.props.OnClikcFilter(this.props.filterName)}
                                />
                            </div>
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            <div
                                style={{
                                    overflow: 'hidden',
                                    opacity: 1,
                                    transition: 'opacity .3s, max-height .2s',
                                    maxHeight: '100%'
                                }}>
                                {forList}
                            </div>
                        </React.Fragment>
                    )}
                </div>
            </div>
        );
    }
}
